import type { UserState } from '~/stores/user'
import type { CoreFetch } from '~/types/CoreFetch'
import type { DeepPartial } from '~/types/utils'

export function providePatchAccountParameter(coreFetch: CoreFetch) {
  return function (user: DeepPartial<UserState>) {
    return coreFetch.$post<UserState>(`/auth/parameter/`, user)
  }
}
